import React, { useState, useEffect, useRef } from 'react';
import API from '../services/api';
import './SiblingPicker.css';

/**
 * "Heyət övladı" seçiləndə valideynin — kompleksdə işləyən əməkdaşın —
 * adını yazarkən mövcud işçilər arasından təklif verir.
 *
 * Seçim MƏCBURİ deyil: siyahıda tapılmasa, yazılan ad olduğu kimi
 * saxlanılır (userId null qalır). Yeni işə götürülmüş, hələ sistemə
 * salınmamış əməkdaş da qeyd edilə bilsin deyə.
 */
export default function StaffPicker({ value, userId, onChange, className = '', placeholder }) {
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const wrapRef = useRef(null);
  const timer = useRef(null);

  // Axtarış yazı dayandıqdan sonra göndərilir — hər hərfdə sorğu atılmır
  useEffect(() => {
    clearTimeout(timer.current);
    const q = (value || '').trim();
    if (q.length < 2 || userId) { setResults([]); return; }
    timer.current = setTimeout(async () => {
      setLoading(true);
      try {
        const { data } = await API.get('/users/search', { params: { q } });
        setResults(data || []);
        setOpen(true);
      } catch { setResults([]); }
      finally { setLoading(false); }
    }, 300);
    return () => clearTimeout(timer.current);
  }, [value, userId]);

  useEffect(() => {
    const onDoc = (e) => { if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, []);

  return (
    <div className="sib-wrap" ref={wrapRef}>
      <div className="sib-field">
        <input
          className={className}
          value={value || ''}
          placeholder={placeholder}
          onChange={e => onChange(e.target.value, null)}   // əl ilə yazanda bağlantı qırılır
          onFocus={() => { if (results.length) setOpen(true); }}
        />
        {userId && (
          <button type="button" className="sib-clear" title="Bağlantını götür"
            onClick={() => onChange(value, null)}>×</button>
        )}
      </div>

      {userId && <div className="sib-linked">Sistemdəki əməkdaşa bağlandı</div>}

      {open && !userId && (results.length > 0 || loading) && (
        <div className="sib-drop">
          {loading && <div className="sib-empty">Axtarılır…</div>}
          {!loading && !results.length && <div className="sib-empty">Tapılmadı</div>}
          {!loading && results.map(u => (
            <button key={u.id} type="button" className="sib-opt"
              onMouseDown={e => e.preventDefault()}
              onClick={() => { onChange(u.name, u.id); setOpen(false); }}>
              <span className="sib-opt-name">{u.name}</span>
              <span className="sib-opt-class">{u.position || u.department_name || '—'}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
